<div class="tab-body">
  <!-- <div *ngIf="validationErrors.length > 0" class="error-message">
                  <p><mat-icon>warning</mat-icon> Please fix the following errors:</p>
                  <ul>
                    <li *ngFor="let error of validationErrors">{{ error }}</li>
                  </ul>
                </div> -->
  <form [formGroup]="addItemForm">
    <div class="form-inputs form-padding">
      <p class="paragraph-medium-regular">Item No.</p>
      <input
        class="disabled-txtbox"
        [disabled]="true"
        formControlName="displayItemNumber"
        [value]="displayItemNumber"
        readonly
      />
    </div>
    <div class="form-inputs">
      <p class="paragraph-medium-regular">Do you have a part/model no.? <span class="required">*</span></p>
      <mat-radio-group
        aria-labelledby="partModelLabel"
        class="part-model-rd-grp"
        name="partModelRdGrp"
        [disabled]="(isModelPartNoValidated && isModelNoFinishedChecking) || isReadOnly"
        (change)="onPartModelOptChange($event)"
        [(ngModel)]="partModelOption"
        [required]="materialSubgroupConditions && materialSubgroupConditions.IsPartNumberRequired"
        [readonly]="isReadOnly"
        [ngModelOptions]="{ standalone: true }"
      >
        <mat-radio-button
          class="part-model-rd"
          *ngFor="let choice of choices"
          [value]="choice"
        >
          {{ choice }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="form-inputs form-padding" *ngIf="partModelOption == 'Yes'">
      <p class="paragraph-medium-regular">
        Part/Model no.
        <span
          class="required"
          *ngIf="materialSubgroupConditions && materialSubgroupConditions?.IsPartNumberRequired"
          >*</span
        >
      </p>
      <input
        class="disabled-txtbox"
        placeholder="E.g. A12345"
        formControlName="PartModelNumber"
      />
      <app-button
        class="padBtn mar-r-10 mar-l-15 partModelNoBtn"
        name="{{ checkButtonTxt }}"
        tabindex="0"
        (keypress)="(PartNoControl.value != '' || !PartNoControl.value) && !isReadOnly && validatePartModelNo()"
        (click)="(PartNoControl.value != '' || !PartNoControl.value) && !isReadOnly && validatePartModelNo()"
        [disabled]="
          !addItemForm.controls['PartModelNumber'].value ||
          isModelPartNoValidated
        "
        [readonly]="isReadOnly"
        type="flat-button"
      ></app-button>
      <mat-spinner
        *ngIf="!isModelNoFinishedChecking && isModelPartNoValidated"
        class="checkSpinner"
      ></mat-spinner>
      <p class="assistive-text paragraph-small-regular">
        Check if your part/model no. is an existing item in the SML List; or if
        the part is obsoleted.
      </p>
    </div>
    <div
      class="form-inputs"
      [ngClass]="isPartNoInSML && isObsolete ? 'partNoValidateMsgObsolete' : ( !isObsolete && !isPartNoInSML ? 'partNoValidateMsgNonExist' :'partNoValidateMsgExist') "
      *ngIf="isModelNoFinishedChecking"
    >
      <span class="iconForNonExistingPartNoHere" *ngIf="(isPartNoInSML && isObsolete) || (!isPartNoInSML && !isObsolete)"
        ><mat-icon>error</mat-icon></span
      >
      <span class="iconForNonExistingPartNoHere" *ngIf="(isPartNoInSML && !isObsolete) || (!isPartNoInSML && isObsolete)"
        ><mat-icon>warning</mat-icon></span
      >
      <span *ngIf="isPartNoInSML && isObsolete">Part/Model no. detected in existing SML list, you may proceed to obtain item from SML store. However, it is classified as obsolete and may no longer be available. Do you still wish to proceed with the purchase?</span
      >
      <span *ngIf="isPartNoInSML && !isObsolete"
        >Part/Model. was detected in existing SML list, you may proceed to obtain item from SML store. Do you still wish to proceed with the purchase?</span
      >
      <span *ngIf="!isPartNoInSML && isObsolete">Part/Model. no. is obsolete and may no longer be available. </span>
      <span  *ngIf="!isPartNoInSML && !isObsolete"
        >Part/Model no. was not detected in existing SML list.
      </span>
      <span><br /></span>
      <!-- <span *ngIf="isPartNoExistInSML">Do you still wish to proceed?</span> -->
      <button class="partNoBtns" [disabled]="isReadOnly"  (click)=" !isReadOnly && resetForm()">Reset</button>
      <button
        class="partNoBtns"
        *ngIf="isPartNoInSML"
        [disabled]="isReadOnly"
        (click)="!actionChosen && !isReadOnly && continueForm($event)"
        [ngClass]="actionChosen ? 'disableProceedBtn' : 'enableProceedBtn'"
      >
        Proceed
      </button>
    </div>
    <div class="form-inputs form-dropdown" *ngIf="isPartNoInSML">
      <p class="paragraph-medium-regular">
        Reason for SML deviation
        <span class="required" *ngIf="isPartNoInSML">*</span>
      </p>
      <ng-select
        [items]="SMLdropdown"
        appearance="outline"
        bindLabel="value"
        addTagText="SML Reason"
        formControlName="SMLReasonId"
        [readonly]="!isModelPartNoValidated || isReadOnly"
        [required]="isPartNoInSML"
      >
      </ng-select>
    </div>
    <div class="form-inputs form-dropdown form-padding pb-4">
      <p class="paragraph-medium-regular">
        Item Description
        <span class="required">*</span>
      </p>
      <app-text-input
        [maxCharCount]="1500"
        [control]="itemDescriptionControl"
        [placeHolderText]="itemDescriptionPlaceHolder"
        [isReadOnly]="isPartNoInSML || isReadOnly"
        class="purpose-text-field item-desc"
      ></app-text-input>
    </div>

    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">Material group*</p>
      <ng-select
        [items]="MatGpdropdown"
        appearance="outline"
        bindLabel="value"
        (change)="onMaterialGroupChange($event)"
        (clear)="resetSubGroup()"
        formControlName="MaterialGroupId"
        [readonly]="!isModelPartNoValidated || isPartNoInSML || isReadOnly"
      >
      </ng-select>
    </div>
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">Material sub group*</p>
      <ng-select
        [items]="MatSGpdropdown"
        appearance="outline"
        bindLabel="value"
        (change)="onMaterialSubGroupChange($event)"
        (clear)="filterMaterialGroup()"
        formControlName="MaterialSubGroupId"
        [readonly]="!isModelPartNoValidated || isPartNoInSML || isReadOnly"
      >
      </ng-select>
    </div>
    <div class="download-message mb-2 paragraph-small-regular"><span class="link" tabindex='0' (keypress)="goMaterialExcelURL()" (click)="goMaterialExcelURL()">Download</span> to view the full excel list of material group and sub group.</div>
    <div *ngIf="materialSubgroupConditions?.IsGEWCA" class="mb-4" style="padding-right:35px;">
      <shared-alert [type]="alertType.Info">
        <ng-container alert-content
          *ngIf="noticeService.gewcaMaterialNoteNotice$ | async as gewcaStatusData; else errorGewcaNoticeTemplate">
          <ng-container *ngIf="gewcaStatusData?.data?.DisplayMessage as gewcaDisplayMessage; else errorGewcaNoticeTemplate">
            <div [innerHTML]="gewcaDisplayMessage | removeNonAscii" class="children--pymy-0"></div>
          </ng-container>
        </ng-container>
      </shared-alert>
      <ng-template #errorGewcaNoticeTemplate>
        <p class="py-0 my-0" alert-content>Unable to retrieve GEWCA notice.</p> 
      </ng-template>
    </div>

    <div *ngIf="materialSubgroupConditions?.RestrictedITProductPolicy?.toLowerCase()?.includes('cat') && purchaseType && ['rfq', 'corporatecard', 'tender', 'dc', 'permissiblecoveringpurchaseorder'].includes(purchaseType)" class="mb-4" style="padding-right:35px;">
      <shared-alert [type]="alertType.Info">
        <ng-container alert-content
          *ngIf="getITProductPolicyNoticeObservable(materialSubgroupConditions) | async as ITProductPolicyStatusData; else errorITProductPolicyNoticeTemplate">
          <ng-container *ngIf="ITProductPolicyStatusData && ITProductPolicyStatusData.data?.DisplayMessage as ITProductPolicyDisplayMessage; else errorITProductPolicyNoticeTemplate">
            <div [innerHTML]="ITProductPolicyDisplayMessage.replaceAll('PRODUCT', materialSubgroupConditions.Name) | removeNonAscii" class="children--pymy-0 children--underline"></div>
          </ng-container>
        </ng-container>
      </shared-alert>
      <ng-template #errorITProductPolicyNoticeTemplate>
        <p class="py-0 my-0" alert-content>Unable to retrieve "Restriction on procurement of IT product policy" notice.</p> 
      </ng-template>
    </div>
    <div *ngIf="isMaterialSubGroupBelongingToMMS(materialSubgroupConditions)" class="item-info__alert mb-4" style="padding-right:35px;">
      <shared-alert [type]="alertType.Error">
          <p alert-content>If you intend to purchase items from this material sub group, please directly raise a PO in MMS.</p>
      </shared-alert>
    </div>
    <div *ngIf="IsExemptedAOR" class="item-info__alert mb-4" style="padding-right:35px;">
      <shared-alert [type]="alertType.Info">
          <p alert-content>The material subgroup you have selected is exempted (for operating budget only) from Approval of Requirements.</p>
      </shared-alert>
    </div>
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">
        COTS/Customised
        <span
          class="required"
          *ngIf="materialSubgroupConditions && materialSubgroupConditions.IsCOTSCustRequired"
          >*</span
        >
      </p>

      <ng-select
        [items]="COTSdropdown"
        appearance="outline"
        bindLabel="value"
        formControlName="isCOTS"
        [readonly]="!isModelPartNoValidated || isReadOnly ||
        (materialSubgroupConditions && !materialSubgroupConditions.IsCOTSChangable)"
        [required]="materialSubgroupConditions && materialSubgroupConditions.IsCOTSCustRequired"
      >
      </ng-select>
    </div>
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">Planned delivery date<span class="required">*</span></p>

      <mat-form-field
      [disabled]="isReadOnly"
      [readonly]="isReadOnly"
      >
        <mat-label>dd/mm/yyyy</mat-label>
        <input
          matInput
          formControlName="PlannedDeliveryDate"
          [matDatepicker]="pickerPlannedDDate"
          id="plannedDDPicker"
          [min]="minDate"
          [disabled]="isReadOnly"
          [readonly]="isReadOnly"
        />
        <mat-error *ngIf="PlannedDeliveryDate.errors && PlannedDeliveryDate.value">Planned delivery date cannot be past date.</mat-error>
        <mat-error *ngIf="PlannedDeliveryDate.errors && !PlannedDeliveryDate.value">Planned delivery date is required.</mat-error>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="pickerPlannedDDate"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerPlannedDDate
        [disabled]="isReadOnly"
        [readonly]="isReadOnly"
        ></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">
        Brand/OEM name
        <span
          class="required"
          *ngIf="materialSubgroupConditions &&materialSubgroupConditions.IsBrandRequired"
          >*</span
        >
      </p>

      <ng-select
        [items]="BOemdropdown"
        appearance="outline"
        bindLabel="value"
        formControlName="BrandOEMName"
        [readonly]="!isModelPartNoValidated || isReadOnly"
        [required]="materialSubgroupConditions && materialSubgroupConditions.IsBrandRequired"
      >
      </ng-select>
      <div class="form-inputs form-padding" *ngIf="BrandOEMNameOther?.id === 'OTH' ">
        <input
          class="disabled-txtbox"
          formControlName="BrandOEMNameCustom"
          placeholder="E.g. Brand"
          id="BrandOEMNameCustom"
          [disabled]="isReadOnly"
          [readonly]="isReadOnly"
          />
          <mat-icon class="close-icon" tabindex="0" (keypress)="clearInput()" (click)="clearInput()">close
          </mat-icon>
      </div>
    </div>
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">
        Workmanship standard
        <span
          class="required"
          *ngIf="materialSubgroupConditions && materialSubgroupConditions.IsIPCClassRequired"
          >*</span
        >
      </p>
      <ng-select
        [items]="WorkSddropdown"
        appearance="outline"
        bindLabel="value"
        formControlName="WorkmanshipId"
        [readonly]="
          !isModelPartNoValidated ||
          (materialSubgroupConditions &&  !materialSubgroupConditions.IsIPCClassChangable) || isReadOnly
        "
        [required]="materialSubgroupConditions && materialSubgroupConditions.IsIPCClassRequired"
      >
      </ng-select>
    </div>
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">
        Criticality Code
        <span
          class="required"
          *ngIf="materialSubgroupConditions && materialSubgroupConditions.IsCriticalityRequired"
          >*</span
        >
      </p>
      <div class="CritCodedropdown-tooltip">
        <ng-select
          [items]="CritCodedropdown"
          appearance="outline"
          bindLabel="value"
          formControlName="CriticalityId"
          dropdownPosition="top"
          [readonly]="!isModelPartNoValidated || isReadOnly"
          [required]="materialSubgroupConditions && materialSubgroupConditions.IsCriticalityRequired"
        >
        </ng-select>
        <ng-template #tooltipTemplateInfo>
          <div class="custom-tooltip">
            <p>
              <strong>Critical</strong>
              <br/>
              An assembly or part that is non-redundant, the failure of which would result in
              loss of weapon system and/or human life.
              <br/>
              <br/>
              An item that perform security functionalities such as encryptor,
              routers/switches, data diode, encrypted hard-disk etc.
              <br/>
              <br/>
              Note: Where a system/item has a back-up, the main system/item should not be
              classified as “critical”. It should be classified as “major”.
              <br/>
              <br/>
              <strong>Major</strong>
              <br/>
              An assembly or part, the failure of which would result in a mission abort or a
              reduction in operational capability.
              <br/>
              <br/>
              <strong>Minor</strong>
              <br/>
              An assembly or part, the failure of which would not result in a loss of weapon
              system, nor cause a reduction in operational capability or mission abort.
            </p>
          </div>
        </ng-template>
        <mat-icon class="custom-tooltip-help-icon" [tp]="tooltipTemplateInfo" 
          tpClassName="custom-tooltip" tpMaxWidth="500px" [tpInteractive]="true" tpPlacement="top">help</mat-icon>
      </div>
    </div>
  </form>
</div>
